import React from "react";
import { useNavigate } from "react-router-dom";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { Card } from "react-bootstrap";
import IconSvg from "../SharedComponents/IconSvg";

/**
 * Page header shared by the SuperAdmin pages: "↰ Parent │ Page title" on the left and a
 * page-specific toolbar (children) on the right. Styled like the pages' other cards
 * (.default-card). The props API is unchanged, so every existing page keeps working.
 *
 * The left card sizes itself to its content (md="auto") and the toolbar fills the rest,
 * so the back link and title stay on one row whatever the title's length.
 */
export default function BreadCrumb({ children, pageName, backPageName, backUrl, backState }) {
  const navigate = useNavigate();

  return (
    <Row className="page-breadcrumb mb-3">
      <Col xs={12} md="auto" className="mb-3 mb-md-0">
        <Card className="default-card page-breadcrumb__nav h-100">
          <button type="button" className="page-breadcrumb__back" onClick={() => navigate(backUrl, backState)}>
            <IconSvg icon="back" height={16} width={16} />
            <span>{backPageName}</span>
          </button>
          <h1 className="page-breadcrumb__title">{pageName}</h1>
        </Card>
      </Col>
      <Col xs={12} md>
        <Card className="default-card page-breadcrumb__toolbar h-100">{children}</Card>
      </Col>
    </Row>
  );
}
